import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxes } from "@fortawesome/pro-regular-svg-icons/faBoxes";

export const defaultTranslations = {
    pluginName: "Product List",
    pluginDescription: "Add products",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faBoxes} size="3x" />,
};
